export default __webpack_public_path__ + "static/camera_w.ea1e59e716484cdf303f4630d7255db2.svg";